import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Card, CardHeader, Col, Container, Input, Row } from "reactstrap";
import { toast } from "react-toastify";
import UiContent from "../../Components/Common/UiContent";
import SignContext from "../../contextAPI/Context/SignContext";
import { useFormSubmit } from "../../hooks/useFormSubmit";

import { useContext, useEffect, useState } from "react";

const Eye = (props) => {
  const [eyeinfo, seteyeinfo] = useState({
    externalexamination: "",
    distandVisionWithRightEye: "",
    distandVisionWithoutRightEye: "",
    distandVisionWithLeftEye: "",
    distandVisionWithoutLeftEye: "",
    nearVisionWithRightEye: "",
    nearVisionWithoutRightEye: "",
    nearVisionWithLeftEye: "",
    nearVisionWithoutLeftEye: "",
    colourVision: "",
    remark: "",
  });
  const { setEyeDetails, GetSpecificEye, editEyeInformation } = useContext(SignContext);
  console.log(props.eye);

  // Debounce hook for form submissions
  const { handleSubmit: debouncedSubmit } = useFormSubmit(500);

  const handleSubmitData = async (values) => {
    const data = {
      ...props,
      chackupNameId: props.chackupNameId,
      checkupTypeId: props.checkupTypeId,
      ...values
    };

    try {
      const response = await setEyeDetails(data);
      console.log(response);

      if (response && (response.data || response.success)) {
        toast.success("Eye examination details saved successfully!");
        if (props.onSuccess && response.data?._id) {
          props.onSuccess(response.data._id);
        }
      }
    } catch (error) {
      console.error("Error saving eye details:", error);
      const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to save eye examination details";
      toast.error(errorMessage);
    }
  };

  const gettingid = async () => {
    if (props.eye !== null) {
      const res = await GetSpecificEye(props.eye);

      seteyeinfo(res.data);
    }
  };
  useEffect(() => {
    gettingid();
  }, [props.eye]);

  return (
    <>
      {props.eye !== null ? (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                eyeinfo,
              }}
              // validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  const data = {
                    ...props,
                    ...eyeinfo,
                    chackupNameId: props.chackupNameId,
                    checkupTypeId: props.checkupTypeId,
                  };
                  console.log(data);
                  try {
                    const res = await editEyeInformation(props.eye, data);
                    if (res && (res.data || res.success)) {
                      toast.success("Eye examination details updated successfully!");
                      if (props.onSuccess) {
                        props.onSuccess(props.eye);
                      }
                    }
                  } catch (error) {
                    console.error("Error:", error);
                    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to update eye examination details";
                    toast.error(errorMessage);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Card>
                    <CardHeader>
                      <Row className="g-1 m-1">
                        <Col className="col-lg-2">
                          <div className="d-flex justify-content-sm-between">
                            <h2 className="card-title mb-0 justify-content-sm-start">
                              <strong>Eye Examination</strong>
                            </h2>
                          </div>
                        </Col>

                        <Col className="col-lg-2 col-md-3 col-12 ">
                          <Input
                            type="text"
                            className="form-control"
                            id="product-orders-input"
                            placeholder=""
                            name="externalexamination"
                            aria-label="orders"
                            aria-describedby="product-orders-addon"
                            onChange={(e) =>
                              seteyeinfo({
                                ...eyeinfo,
                                externalexamination: e.target.value,
                              })
                            }
                            onBlur={handleBlur}
                            value={
                              eyeinfo
                                ? eyeinfo.externalexamination !== null &&
                                  eyeinfo.externalexamination !== ""
                                  ? eyeinfo.externalexamination
                                  : ""
                                : ""
                            }
                          />
                          <p className="error text-danger">
                            {errors.gallaryCategoryTitle &&
                              touched.gallaryCategoryTitle &&
                              errors.gallaryCategoryTitle}
                          </p>
                        </Col>
                      </Row>
                    </CardHeader>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className="align-items-center g-3">
                          <Col className="col-lg-4 col-md-6 col-sm  col-2">
                            <div className="d-flex justify-content-sm-between">
                              <h5 className="">Acuity of Vision</h5>
                            </div>
                          </Col>

                          <Col className="col-lg-2 col-md-3 text-center">
                            Left Eye
                          </Col>
                          <Col className="col-lg-2 col-md-3 text-center">
                            Right Eye
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3 mt-2">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3 ">
                                    Distant vision
                                  </Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>w/o glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithoutLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          distandVisionWithoutLeftEye:
                                            e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.distandVisionWithoutLeftEye !==
                                            null &&
                                            eyeinfo.distandVisionWithoutLeftEye !==
                                            ""
                                            ? eyeinfo.distandVisionWithoutLeftEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle &&
                                        touched.gallaryCategoryTitle &&
                                        errors.gallaryCategoryTitle}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithoutRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          distandVisionWithoutRightEye:
                                            e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.distandVisionWithoutRightEye !==
                                            null &&
                                            eyeinfo.distandVisionWithoutRightEye !==
                                            ""
                                            ? eyeinfo.distandVisionWithoutRightEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle2 &&
                                        touched.gallaryCategoryTitle2 &&
                                        errors.gallaryCategoryTitle2}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3"></Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>with glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          distandVisionWithLeftEye:
                                            e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.distandVisionWithLeftEye !==
                                            null &&
                                            eyeinfo.distandVisionWithLeftEye !==
                                            ""
                                            ? eyeinfo.distandVisionWithLeftEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle3 &&
                                        touched.gallaryCategoryTitle3 &&
                                        errors.gallaryCategoryTitle3}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          distandVisionWithRightEye:
                                            e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.distandVisionWithRightEye !==
                                            null &&
                                            eyeinfo.distandVisionWithRightEye !==
                                            ""
                                            ? eyeinfo.distandVisionWithRightEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle4 &&
                                        touched.gallaryCategoryTitle4 &&
                                        errors.gallaryCategoryTitle4}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-center g-3 ">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3">
                                    Near vision
                                  </Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>w/o glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithoutLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          nearVisionWithoutLeftEye:
                                            e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.nearVisionWithoutLeftEye !==
                                            null &&
                                            eyeinfo.nearVisionWithoutLeftEye !==
                                            ""
                                            ? eyeinfo.nearVisionWithoutLeftEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle5 &&
                                        touched.gallaryCategoryTitle5 &&
                                        errors.gallaryCategoryTitle5}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithoutRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          nearVisionWithoutRightEye:
                                            e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.nearVisionWithoutRightEye !==
                                            null &&
                                            eyeinfo.nearVisionWithoutRightEye !==
                                            ""
                                            ? eyeinfo.nearVisionWithoutRightEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle6 &&
                                        touched.gallaryCategoryTitle6 &&
                                        errors.gallaryCategoryTitle6}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3"></Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>with glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          nearVisionWithLeftEye: e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.nearVisionWithLeftEye !==
                                            null &&
                                            eyeinfo.nearVisionWithLeftEye !== ""
                                            ? eyeinfo.nearVisionWithLeftEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle7 &&
                                        touched.gallaryCategoryTitle7 &&
                                        errors.gallaryCategoryTitle7}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={(e) =>
                                        seteyeinfo({
                                          ...eyeinfo,
                                          nearVisionWithRightEye:
                                            e.target.value,
                                        })
                                      }
                                      onBlur={handleBlur}
                                      value={
                                        eyeinfo
                                          ? eyeinfo.nearVisionWithRightEye !==
                                            null &&
                                            eyeinfo.nearVisionWithRightEye !==
                                            ""
                                            ? eyeinfo.nearVisionWithRightEye
                                            : ""
                                          : ""
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle8 &&
                                        touched.gallaryCategoryTitle8 &&
                                        errors.gallaryCategoryTitle8}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <Row className="align-items-center g-3">
                        <Col className="col-sm">
                          <div>
                            <div>
                              <Row className="mb-3">
                                <Col className="col-lg-2 col-md-3"></Col>
                                <Col className="col-lg-2 col-md-3">
                                  <p>Colour Vision</p>
                                </Col>

                                <Col className="col-lg-4 col-md-6">
                                  <textarea
                                    className="form-control"
                                    id="meassageInput"
                                    type="text"
                                    rows="3"
                                    name="colourVision"
                                    placeholder="Type Normal if patient has no colour vision"
                                    onChange={(e) =>
                                      seteyeinfo({
                                        ...eyeinfo,
                                        colourVision: e.target.value,
                                      })
                                    }
                                    onBlur={handleBlur}
                                    value={
                                      eyeinfo
                                        ? eyeinfo.colourVision !== null &&
                                          eyeinfo.colourVision !== ""
                                          ? eyeinfo.colourVision
                                          : ""
                                        : ""
                                    }
                                  ></textarea>
                                  {/* <p className="error text-danger">
                                    {errors.gallaryCategoryTitle9 &&
                                      touched.gallaryCategoryTitle9 &&
                                      errors.gallaryCategoryTitle9}
                                  </p> */}
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="align-items-center g-3">
                        <Col className="col-sm">
                          <div>
                            <div>
                              <Row className="mb-3">
                                <Col className="col-lg-2 col-md-3"></Col>
                                <Col className="col-lg-2 col-md-3">
                                  <p>Remarks</p>
                                </Col>

                                <Col className="col-lg-4 col-md-6">
                                  <textarea
                                    className="form-control"
                                    id="meassageInput"
                                    type="text"
                                    rows="3"
                                    name="remark"
                                    placeholder="remarks"
                                    onChange={(e) =>
                                      seteyeinfo({
                                        ...eyeinfo,
                                        remark: e.target.value,
                                      })
                                    }
                                    onBlur={handleBlur}
                                    value={
                                      eyeinfo
                                        ? eyeinfo.remark !== null &&
                                          eyeinfo.remark !== ""
                                          ? eyeinfo.remark
                                          : ""
                                        : ""
                                    }
                                  ></textarea>
                                  {/* <p className="error text-danger">
                                    {errors.gallaryCategoryTitle9 &&
                                      touched.gallaryCategoryTitle9 &&
                                      errors.gallaryCategoryTitle9}
                                  </p> */}
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className="text-end mb-1 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Updating...
                          </>
                        ) : (
                          'Update'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                externalexamination: "",
                distandVisionWithRightEye: "",
                distandVisionWithoutRightEye: "",
                distandVisionWithLeftEye: "",
                distandVisionWithoutLeftEye: "",
                nearVisionWithRightEye: "",
                nearVisionWithoutRightEye: "",
                nearVisionWithLeftEye: "",
                nearVisionWithoutLeftEye: "",
                colourVision: "",
                remark: "",
              }}
              // validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  console.log(">>>>>vaishal", values);
                  try {
                    await handleSubmitData(values);
                  } catch (error) {
                    console.error("Error:", error);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Card>
                    <CardHeader>
                      <Row className="g-1 m-1">
                        <Col className="col-lg-2">
                          <div className="d-flex justify-content-sm-between mt-2">
                            <h2 className="card-title mb-0 justify-content-sm-start">
                              <strong>External Eye Examination</strong>
                            </h2>
                          </div>
                        </Col>
                        <Col className="col-lg-2 col-md-3 col-12 ">
                          <Input
                            type="text"
                            className="form-control"
                            id="product-orders-input"
                            placeholder=""
                            name="externalexamination"
                            aria-label="orders"
                            aria-describedby="product-orders-addon"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.externalexamination}
                          />
                          <p className="error text-danger">
                            {errors.gallaryCategoryTitle &&
                              touched.gallaryCategoryTitle &&
                              errors.gallaryCategoryTitle}
                          </p>
                        </Col>
                      </Row>
                    </CardHeader>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className="align-items-center g-3">
                          <Col className="col-lg-4 col-md-6  col-sm  col-2">
                            <div className="d-flex justify-content-sm-between">
                              <h5 className="">Acuity of Vision</h5>
                            </div>
                          </Col>

                          <Col className="col-lg-2 col-md-3 text-center">
                            Left Eye
                          </Col>
                          <Col className="col-lg-2 col-md-3 text-center">
                            Right Eye
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3 mt-2">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3">
                                    Distant vision
                                  </Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>w/o glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithoutLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.distandVisionWithoutLeftEye}
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle &&
                                        touched.gallaryCategoryTitle &&
                                        errors.gallaryCategoryTitle}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithoutRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={
                                        values.distandVisionWithoutRightEye
                                      }
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle2 &&
                                        touched.gallaryCategoryTitle2 &&
                                        errors.gallaryCategoryTitle2}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3"></Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>with glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.distandVisionWithLeftEye}
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle3 &&
                                        touched.gallaryCategoryTitle3 &&
                                        errors.gallaryCategoryTitle3}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="distandVisionWithRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.distandVisionWithRightEye}
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle4 &&
                                        touched.gallaryCategoryTitle4 &&
                                        errors.gallaryCategoryTitle4}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-center g-3 ">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3">
                                    Near vision
                                  </Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>w/o glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithoutLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.nearVisionWithoutLeftEye}
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle5 &&
                                        touched.gallaryCategoryTitle5 &&
                                        errors.gallaryCategoryTitle5}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithoutRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.nearVisionWithoutRightEye}
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle6 &&
                                        touched.gallaryCategoryTitle6 &&
                                        errors.gallaryCategoryTitle6}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col className="col-sm">
                            <div>
                              <div>
                                <Row>
                                  <Col className="col-lg-2 col-md-3"></Col>
                                  <Col className="col-lg-2 col-md-3">
                                    <p>with glasses</p>
                                  </Col>

                                  <Col className="col-lg-2 col-md-3 col-12">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithLeftEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.nearVisionWithLeftEye}
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle7 &&
                                        touched.gallaryCategoryTitle7 &&
                                        errors.gallaryCategoryTitle7}
                                    </p>
                                  </Col>
                                  <Col className="col-lg-2 col-md-3 col-12 ">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder=""
                                      name="nearVisionWithRightEye"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.nearVisionWithRightEye}
                                    />
                                    <p className="error text-danger">
                                      {errors.gallaryCategoryTitle8 &&
                                        touched.gallaryCategoryTitle8 &&
                                        errors.gallaryCategoryTitle8}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <Row className="align-items-center g-3">
                        <Col className="col-sm">
                          <div>
                            <div>
                              <Row className="mb-3">
                                <Col className="col-lg-2 col-md-3"></Col>
                                <Col className="col-lg-2 col-md-3">
                                  <p>Colour Vision</p>
                                </Col>

                                <Col className="col-lg-4 col-md-6">
                                  <textarea
                                    className="form-control"
                                    id="meassageInput"
                                    type="text"
                                    rows="3"
                                    name="colourVision"
                                    placeholder="Type Normal if patient has no colour vision"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.colourVision}
                                  ></textarea>
                                  {/* <p className="error text-danger">
                                    {errors.gallaryCategoryTitle9 &&
                                      touched.gallaryCategoryTitle9 &&
                                      errors.gallaryCategoryTitle9}
                                  </p> */}
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="align-items-center g-3">
                        <Col className="col-sm">
                          <div>
                            <div>
                              <Row className="mb-3">
                                <Col className="col-lg-2 col-md-3"></Col>
                                <Col className="col-lg-2 col-md-3">
                                  <p>Remarks</p>
                                </Col>

                                <Col className="col-lg-4 col-md-6">
                                  <textarea
                                    className="form-control"
                                    id="meassageInput"
                                    type="text"
                                    rows="3"
                                    name="remark"
                                    placeholder="remarks"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.remark}
                                  ></textarea>
                                  {/* <p className="error text-danger">
                                    {errors.gallaryCategoryTitle9 &&
                                      touched.gallaryCategoryTitle9 &&
                                      errors.gallaryCategoryTitle9}
                                  </p> */}
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className="text-end mb-1 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Submitting...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Eye;
